import { Button, DataSource, HorizontalSpacer, Label, Layout, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDetentionDetails extends Layout {
    buttonRecalculate: Button;
    horizontalspacer1: HorizontalSpacer;
    labelCharges: Label;
    labelPay: Label;
    sourceDetentionHist: DataSource;
    sourceDetentionHistChg: DataSource;
    sourceDetentionHistPay: DataSource;
    sourceStop: DataSource;
    switchBillingApproval: Switch;
    tabDetentionChargesPay: Tab;
    tabDetentionDetails: Tab;
    tableCharges: Table;
    tablePayments: Table;
    tabsetDetentionChargesAndPay: Tabset;
    tabsetDetentionDetails: Tabset;
    textbotWarning: Textbox;
    textboxArrival: Textbox;
    textboxAuthStatus: Textbox;
    textboxChangerFeeTimeEnds: Textbox;
    textboxChangerFeeTimeStarts: Textbox;
    textboxCharge: Textbox;
    textboxDeparture: Textbox;
    textboxFreeTime: Textbox;
    textboxPaymentApproval: Textbox;
    textboxTotalDetention: Textbox;
}
